module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 6
// module chunks = 0